import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i3 from 'base-job-description-library';
import { BaseJobDescriptionLibraryService } from 'base-job-description-library';
import { first } from 'rxjs/internal/operators/first';
import * as i18 from 'help-video-overlay-library';
import { HelpVideoOverlayLibraryComponent, HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import * as i1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@ngrx/store';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i6 from 'dirty-check-store';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from 'primeng/dynamicdialog';
import * as i10 from 'app-services-library';
import * as i11 from 'list-job-duties';
import { ListJobDutiesModule } from 'list-job-duties';
import * as i12 from '@angular/common';
import * as i13 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i14 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i15 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i16 from 'primeng/divider';
import * as i17 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i19 from 'primeng/radiobutton';
import * as i20 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i21 from 'primeng/button';
import * as i22 from 'primeng/inputtext';
import * as i23 from 'primeng/calendar';
import * as i24 from 'primeng/inputswitch';
import * as i25 from 'primeng/dropdown';
import * as i26 from 'h1b-job-description';
import { H1bJobDescriptionModule } from 'h1b-job-description';
import * as i27 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import * as i28 from 'primeng/api';
import * as i29 from 'primeng/tooltip';
import * as i30 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';
import { JobDutiesLibraryModule } from 'job-duties-library';

class JobDescriptionLibraryService {
    constructor() { }
}
JobDescriptionLibraryService.ɵfac = function JobDescriptionLibraryService_Factory(t) { return new (t || JobDescriptionLibraryService)(); };
JobDescriptionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: JobDescriptionLibraryService, factory: JobDescriptionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["jobDescriptionForm"];
function JobDescriptionLibraryComponent_h5_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 4);
    i0.ɵɵtext(1, "Enter Proposed Job Description");
    i0.ɵɵelementEnd();
} }
function JobDescriptionLibraryComponent_h5_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 4);
    i0.ɵɵtext(1, "Enter Current Job Description(Foreign Company)");
    i0.ɵɵelementEnd();
} }
function JobDescriptionLibraryComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "p-radioButton", 34);
    i0.ɵɵlistener("onClick", function JobDescriptionLibraryComponent_div_29_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleWorkLocationChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r3.disabledControls);
} }
function JobDescriptionLibraryComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "p-radioButton", 36);
    i0.ɵɵlistener("onClick", function JobDescriptionLibraryComponent_div_30_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleWorkLocationChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_1_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_1_div_5_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.jobDescriptionForm.controls["clientName"].errors == null ? null : ctx_r20.jobDescriptionForm.controls["clientName"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelementStart(2, "label", 62);
    i0.ɵɵtext(3, " Client Name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 77);
    i0.ɵɵtemplate(5, JobDescriptionLibraryComponent_div_31_div_1_div_5_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r10.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.jobDescriptionForm.controls["clientName"].touched && ctx_r10.jobDescriptionForm.controls["clientName"].invalid);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_1_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 96);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" (+", item_r26.phoneCode, ") - ", item_r26.countryName, " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "p-dropdown", 94);
    i0.ɵɵtemplate(2, JobDescriptionLibraryComponent_div_31_div_2_div_1_div_5_ng_template_2_Template, 3, 2, "ng-template", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", ctx_r24.countryList)("filter", false)("disabled", ctx_r24.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 88);
    i0.ɵɵelementStart(2, "label", 58);
    i0.ɵɵtext(3, " Phone Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtemplate(5, JobDescriptionLibraryComponent_div_31_div_2_div_1_div_5_Template, 3, 3, "div", 89);
    i0.ɵɵelementStart(6, "div", 90);
    i0.ɵɵelement(7, "input", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 88);
    i0.ɵɵelementStart(9, "label", 58);
    i0.ɵɵtext(10, " Email ID ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r22.isForeignCompany);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r22.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r22.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 109);
    i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_div_31_div_2_div_3_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); const item_r27 = ctx_r39.$implicit; const addressIndex_r28 = ctx_r39.index; const ctx_r38 = i0.ɵɵnextContext(3); return ctx_r38.handleDeleteWorkLocation(item_r27, addressIndex_r28); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r29.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_9_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("addressLine1").errors == null ? null : item_r27.get("addressLine1").errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_14_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_14_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("addressLine2").errors == null ? null : item_r27.get("addressLine2").errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r46.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_div_4_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["countryCode"].errors == null ? null : item_r27.controls["countryCode"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "label", 62);
    i0.ɵɵtext(2, " Country ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 111);
    i0.ɵɵlistener("onChange", function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r50); const item_r27 = i0.ɵɵnextContext().$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.handleCountryChange($event.value, item_r27, true); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_div_4_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r32.countryList)("disabled", ctx_r32.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["countryCode"].touched && item_r27.controls["countryCode"].invalid);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_div_4_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["stateProvinceCode"].errors == null ? null : item_r27.controls["stateProvinceCode"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "label", 62);
    i0.ɵɵtext(2, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 112);
    i0.ɵɵtemplate(4, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_div_4_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", item_r27.get("stateList").value)("disabled", ctx_r33.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["stateProvinceCode"].touched && item_r27.controls["stateProvinceCode"].invalid);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r57.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_div_4_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["stateProvinceName"].errors == null ? null : item_r27.controls["stateProvinceName"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵelementStart(1, "label", 58);
    i0.ɵɵtext(2, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 113);
    i0.ɵɵtemplate(4, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_div_4_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r34.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.controls["stateProvinceName"].touched && item_r27.controls["stateProvinceName"].invalid);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r60.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r61.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵtemplate(2, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_span_2_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("city").errors == null ? null : item_r27.get("city").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("city").errors == null ? null : item_r27.get("city").errors.pattern);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_27_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r63.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_27_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("postCode").errors == null ? null : item_r27.get("postCode").errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_p_divider_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 114);
} }
function JobDescriptionLibraryComponent_div_31_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 97);
    i0.ɵɵelementStart(2, "div", 98);
    i0.ɵɵtemplate(3, JobDescriptionLibraryComponent_div_31_div_2_div_3_button_3_Template, 1, 1, "button", 99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 100);
    i0.ɵɵelementStart(5, "div", 76);
    i0.ɵɵelementStart(6, "label", 62);
    i0.ɵɵtext(7, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 101);
    i0.ɵɵtemplate(9, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_9_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 88);
    i0.ɵɵelementStart(11, "label", 58);
    i0.ɵɵtext(12, " Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 102);
    i0.ɵɵtemplate(14, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_14_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_15_Template, 5, 3, "div", 103);
    i0.ɵɵtemplate(16, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_16_Template, 5, 3, "div", 103);
    i0.ɵɵtemplate(17, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_17_Template, 5, 2, "div", 104);
    i0.ɵɵelementStart(18, "div", 105);
    i0.ɵɵelementStart(19, "label", 62);
    i0.ɵɵtext(20, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 106);
    i0.ɵɵtemplate(22, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_22_Template, 3, 2, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 105);
    i0.ɵɵelementStart(24, "label", 62);
    i0.ɵɵtext(25, " Postal Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "input", 107);
    i0.ɵɵtemplate(27, JobDescriptionLibraryComponent_div_31_div_2_div_3_div_27_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, JobDescriptionLibraryComponent_div_31_div_2_div_3_p_divider_28_Template, 1, 0, "p-divider", 108);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = ctx.$implicit;
    const addressIndex_r28 = ctx.index;
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", addressIndex_r28);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", addressIndex_r28 != "0");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r23.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("addressLine1").touched && item_r27.get("addressLine1").invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r23.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("addressLine2").touched && item_r27.get("addressLine2").invalid);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.isForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("stateList").value && item_r27.get("stateList").value.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("stateList").value && item_r27.get("stateList").value.length <= 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r23.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("city").touched && item_r27.get("city").invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r23.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.get("postCode").touched && item_r27.get("postCode").invalid);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressIndex_r28 < ctx_r23.getAddressFormArray().length - 1);
} }
function JobDescriptionLibraryComponent_div_31_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_2_div_1_Template, 12, 3, "div", 81);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtemplate(3, JobDescriptionLibraryComponent_div_31_div_2_div_3_Template, 29, 14, "div", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-divider", 84);
    i0.ɵɵelementStart(5, "div", 85);
    i0.ɵɵelementStart(6, "div", 86);
    i0.ɵɵelementStart(7, "button", 87);
    i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_div_31_div_2_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(2); return ctx_r65.handleAddLocationClick(); });
    i0.ɵɵtext(8, "Add Locations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.inputData.visatype !== "L1A" && (ctx_r11.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY" || ctx_r11.jobDescriptionForm.get("workLocationTypeCode").value === "INHSECLT"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r11.getAddressFormArray());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r11.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "div", 123);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Vendor Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 124);
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8, "Vendor Point of Contact");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLibraryComponent_div_31_div_3_div_6_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 134);
    i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_div_31_div_3_div_6_button_17_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r74); const vendorIndex_r70 = i0.ɵɵnextContext().index; const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.deleteVendor(vendorIndex_r70); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r71.disabledControls);
} }
function JobDescriptionLibraryComponent_div_31_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "div", 125);
    i0.ɵɵelementStart(2, "div", 126);
    i0.ɵɵelementStart(3, "label", 58);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "input", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 128);
    i0.ɵɵelementStart(7, "label", 58);
    i0.ɵɵtext(8, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 128);
    i0.ɵɵelementStart(11, "label", 58);
    i0.ɵɵtext(12, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 130);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 131);
    i0.ɵɵelement(15, "label", 58);
    i0.ɵɵelementStart(16, "button", 132);
    i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_div_31_div_3_div_6_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(3); return ctx_r75.addVendor(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, JobDescriptionLibraryComponent_div_31_div_3_div_6_button_17_Template, 1, 1, "button", 133);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vendorIndex_r70 = ctx.index;
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", vendorIndex_r70);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r68.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r68.disabledControls);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r68.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r68.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r68.jobDescriptionForm.get("vendorList").value.length > 1);
} }
function JobDescriptionLibraryComponent_div_31_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 115);
    i0.ɵɵelement(1, "p-divider", 116);
    i0.ɵɵelementStart(2, "div", 117);
    i0.ɵɵelementStart(3, "p-checkbox", 118);
    i0.ɵɵlistener("onChange", function JobDescriptionLibraryComponent_div_31_div_3_Template_p_checkbox_onChange_3_listener($event) { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(2); return ctx_r77.handleVendorChkboxChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 119);
    i0.ɵɵtemplate(5, JobDescriptionLibraryComponent_div_31_div_3_div_5_Template, 9, 0, "div", 120);
    i0.ɵɵtemplate(6, JobDescriptionLibraryComponent_div_31_div_3_div_6_Template, 18, 6, "div", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r12.jobDescriptionForm.get("isMiddleVendor").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.getVendorListFormArray());
} }
function JobDescriptionLibraryComponent_div_31_div_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r79.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_13_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.jobDescriptionForm.controls["jobTitle"].errors == null ? null : ctx_r13.jobDescriptionForm.controls["jobTitle"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_20_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_20_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.jobDescriptionForm.controls["startDate"].errors == null ? null : ctx_r14.jobDescriptionForm.controls["startDate"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_26_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r81.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_26_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.jobDescriptionForm.controls["endDate"].errors == null ? null : ctx_r15.jobDescriptionForm.controls["endDate"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 79);
    i0.ɵɵtext(2, " End date should be greater than or equal to Start Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLibraryComponent_div_31_div_36_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r83.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_36_div_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r84.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_36_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_36_div_5_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵtemplate(2, JobDescriptionLibraryComponent_div_31_div_36_div_5_span_2_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.jobDescriptionForm.get("workingHoursPerWeek").errors == null ? null : ctx_r82.jobDescriptionForm.get("workingHoursPerWeek").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.jobDescriptionForm.get("workingHoursPerWeek").errors == null ? null : ctx_r82.jobDescriptionForm.get("workingHoursPerWeek").errors.pattern);
} }
function JobDescriptionLibraryComponent_div_31_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "label", 135);
    i0.ɵɵtext(3, " Working Hours per week ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 136);
    i0.ɵɵtemplate(5, JobDescriptionLibraryComponent_div_31_div_36_div_5_Template, 3, 2, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r17.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.jobDescriptionForm.get("workingHoursPerWeek").touched && ctx_r17.jobDescriptionForm.get("workingHoursPerWeek").invalid);
} }
function JobDescriptionLibraryComponent_div_31_div_47_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r85.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_47_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r86.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_47_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵtemplate(2, JobDescriptionLibraryComponent_div_31_div_47_span_2_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.jobDescriptionForm.controls["wagesFrom"].errors == null ? null : ctx_r18.jobDescriptionForm.controls["wagesFrom"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.jobDescriptionForm.controls["wagesFrom"].errors == null ? null : ctx_r18.jobDescriptionForm.controls["wagesFrom"].errors.pattern);
} }
function JobDescriptionLibraryComponent_div_31_div_52_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r87.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLibraryComponent_div_31_div_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_52_span_1_Template, 2, 1, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.jobDescriptionForm.controls["wageTypeCode"].errors == null ? null : ctx_r19.jobDescriptionForm.controls["wageTypeCode"].errors.required);
} }
function JobDescriptionLibraryComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, JobDescriptionLibraryComponent_div_31_div_1_Template, 6, 2, "div", 38);
    i0.ɵɵtemplate(2, JobDescriptionLibraryComponent_div_31_div_2_Template, 9, 3, "div", 39);
    i0.ɵɵtemplate(3, JobDescriptionLibraryComponent_div_31_div_3_Template, 7, 2, "div", 40);
    i0.ɵɵelement(4, "p-divider", 41);
    i0.ɵɵelementStart(5, "div", 42);
    i0.ɵɵelementStart(6, "h5", 20);
    i0.ɵɵtext(7, "Position Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 43);
    i0.ɵɵelementStart(9, "div", 44);
    i0.ɵɵelementStart(10, "label", 45);
    i0.ɵɵtext(11, " Position Title ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 46);
    i0.ɵɵtemplate(13, JobDescriptionLibraryComponent_div_31_div_13_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 48);
    i0.ɵɵelementStart(15, "div", 49);
    i0.ɵɵelementStart(16, "label", 50);
    i0.ɵɵtext(17, " Start Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "br");
    i0.ɵɵelement(19, "p-calendar", 51);
    i0.ɵɵtemplate(20, JobDescriptionLibraryComponent_div_31_div_20_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 52);
    i0.ɵɵelementStart(22, "label", 53);
    i0.ɵɵtext(23, " End Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "br");
    i0.ɵɵelement(25, "p-calendar", 54);
    i0.ɵɵtemplate(26, JobDescriptionLibraryComponent_div_31_div_26_Template, 2, 1, "div", 47);
    i0.ɵɵtemplate(27, JobDescriptionLibraryComponent_div_31_div_27_Template, 3, 0, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 41);
    i0.ɵɵelementStart(29, "div", 55);
    i0.ɵɵelementStart(30, "div", 56);
    i0.ɵɵelementStart(31, "div", 57);
    i0.ɵɵelementStart(32, "label", 58);
    i0.ɵɵtext(33, "Is this a full time position?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 28);
    i0.ɵɵelement(35, "p-inputSwitch", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(36, JobDescriptionLibraryComponent_div_31_div_36_Template, 6, 2, "div", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 42);
    i0.ɵɵelementStart(38, "h5", 20);
    i0.ɵɵtext(39, "Wage offer Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 61);
    i0.ɵɵelementStart(41, "div", 44);
    i0.ɵɵelementStart(42, "label", 62);
    i0.ɵɵtext(43, " Wage ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "span", 63);
    i0.ɵɵelement(45, "i", 64);
    i0.ɵɵelement(46, "input", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(47, JobDescriptionLibraryComponent_div_31_div_47_Template, 3, 2, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 66);
    i0.ɵɵelementStart(49, "label", 62);
    i0.ɵɵtext(50, " Wage Unit ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "p-dropdown", 67);
    i0.ɵɵlistener("onChange", function JobDescriptionLibraryComponent_div_31_Template_p_dropdown_onChange_51_listener($event) { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(); return ctx_r88.onWageUnitChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(52, JobDescriptionLibraryComponent_div_31_div_52_Template, 2, 1, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 44);
    i0.ɵɵelementStart(54, "label", 62);
    i0.ɵɵtext(55, " Annual Compensation ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "span", 63);
    i0.ɵɵelement(57, "i", 64);
    i0.ɵɵelement(58, "input", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 41);
    i0.ɵɵelement(60, "lib-h1b-job-description", 69);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(61, "div", 42);
    i0.ɵɵelementStart(62, "h5", 70);
    i0.ɵɵtext(63, "Upload Offer Related Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(64, "div", 41);
    i0.ɵɵelement(65, "file-upload-library", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(66, "div", 41);
    i0.ɵɵelementStart(67, "div", 72);
    i0.ɵɵelementStart(68, "div", 73);
    i0.ɵɵelementStart(69, "h5");
    i0.ɵɵelementStart(70, "b");
    i0.ɵɵtext(71, "List Of Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(72, "list-job-duties", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    let tmp_27_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.inputData.visatype !== "L1A" && (ctx_r5.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY" || ctx_r5.jobDescriptionForm.get("workLocationTypeCode").value === "INHSECLT"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.get("workLocationTypeCode").value != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.get("workLocationTypeCode").value === "TPARTY");
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("readonly", ctx_r5.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["jobTitle"].touched && ctx_r5.jobDescriptionForm.controls["jobTitle"].invalid);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls)("showIcon", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["startDate"].touched && ctx_r5.jobDescriptionForm.controls["startDate"].invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls)("showIcon", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["endDate"].touched && ctx_r5.jobDescriptionForm.controls["endDate"].invalid);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["endDate"].errors == null ? null : ctx_r5.jobDescriptionForm.controls["endDate"].errors.positionDateValidation);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.jobDescriptionForm.get("thisFulltime").value);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("readonly", ctx_r5.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["wagesFrom"].touched && ctx_r5.jobDescriptionForm.controls["wagesFrom"].invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r5.wageUnitType)("filter", false)("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobDescriptionForm.controls["wageTypeCode"].touched && ctx_r5.jobDescriptionForm.controls["wageTypeCode"].invalid);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("readonly", ctx_r5.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("parentForm", ctx_r5.jobDescriptionForm)("disabledControls", ctx_r5.disabledControls)("beneficiaryId", ctx_r5.primaryData == null ? null : ctx_r5.primaryData.beneficiaryId);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("fileUploadConfigurations", ctx_r5.fileUploadConfigurations);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("inputData", ctx_r5.inputData)("isSave", false)("jobDescription", ctx_r5.jobDescriptionForm == null ? null : (tmp_27_0 = ctx_r5.jobDescriptionForm.get("jobTitle")) == null ? null : tmp_27_0.value);
} }
const _c1 = function (a0) { return { layoutCode: a0 }; };
const _c2 = function (a0) { return { hideView: a0 }; };
class JobDescriptionLibraryComponent extends BaseJobDescriptionLibraryService {
    constructor(jobDescriptionBuilder, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, changeDetector, dialogService, customValidator, appServicesLibraryService, listJobDutiesService) {
        super(jobDescriptionBuilder, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, changeDetector, dialogService, customValidator, appServicesLibraryService);
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.changeDetector = changeDetector;
        this.dialogService = dialogService;
        this.customValidator = customValidator;
        this.appServicesLibraryService = appServicesLibraryService;
        this.listJobDutiesService = listJobDutiesService;
        this.onDialogClose = new EventEmitter();
        this.dutiesList = [];
        this.showNext = false;
        this.showPrev = false;
        this.userType = sessionStorage.getItem("userTypeRole");
    }
    ngOnInit() {
        var _a, _b;
        this.isForeignCompany = this.isForeignCompany;
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        super.loadInit();
        this.listJobDutiesService.getDuties().subscribe(res => {
            this.dutiesList = res;
        });
    }
    ngAfterViewInit() {
        this.jobDescriptionForm = this.jobDescriptionForm;
        this.helpVideoComponent.setValues('right', 'Designing a Job Description', 'Designing A Job Description');
        super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.onDestroy();
    }
    postJobDescription() {
        super.postJobDescription(this.dutiesList);
    }
}
JobDescriptionLibraryComponent.ɵfac = function JobDescriptionLibraryComponent_Factory(t) { return new (t || JobDescriptionLibraryComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.APIJobDescription), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i6.DirtyFormGuard), i0.ɵɵdirectiveInject(i7.CacheCountryListService), i0.ɵɵdirectiveInject(i8.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i9.DialogService), i0.ɵɵdirectiveInject(i3.DateValidators), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService), i0.ɵɵdirectiveInject(i11.ListJobDutiesService)); };
JobDescriptionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDescriptionLibraryComponent, selectors: [["job-description-library"]], viewQuery: function JobDescriptionLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(HelpVideoOverlayLibraryComponent, 1);
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpVideoComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.jobDescriptionForm = _t.first);
    } }, inputs: { isForeignCompany: "isForeignCompany", primaryData: "primaryData", deleteAllDutie: "deleteAllDutie", addUpdateDuty: "addUpdateDuty", deleteDuty: "deleteDuty", deleteSubDuty: "deleteSubDuty", parentForm: "parentForm" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 43, vars: 39, consts: [[1, "container-fuild"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title"], ["class", "mb-0", 4, "ngIf"], [1, "mb-0"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], [3, "formGroup", "ngSubmit"], [1, "main-body", "footer-adjust-v2"], ["sectionCode", "JD", 3, "inputDetails", "primaryData"], ["helpVideoComponent", ""], [1, "row", "col-md-12", "mb-3"], [1, "sub-title"], [1, "col-3", "pl-0"], ["name", "workLocationTypeCode", "styleClass", "radio-style", "formControlName", "workLocationTypeCode", "value", "INHSE", "label", "In-House", 1, "p-col", 3, "disabled", "onClick"], ["class", "col-3 pl-0", 4, "ngIf"], ["class", "col-6 pl-0", 4, "ngIf"], ["class", "row col-md-12 pl-0", 4, "ngIf"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"], [1, "row", 3, "ngClass"], [1, "col-md-1"], ["pButton", "", "type", "submit", "label", "Save", "title", "Save", 3, "ngClass", "disabled"], [1, "col-md-2"], ["pButton", "", "type", "button", "label", "Cancel", 1, "p-button-secondary", "cancel-btn", "button-width-icon-left", "d-flex", "alogn-items-center", 3, "disabled", "click"], [1, "col-md-7", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "isViewMode", "isCaseRequest", "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], ["name", "workLocationTypeCode", "formControlName", "workLocationTypeCode", "value", "TPARTY", "label", "Third Party Site", 3, "disabled", "onClick"], [1, "col-6", "pl-0"], ["name", "workLocationTypeCode", "formControlName", "workLocationTypeCode", "value", "INHSECLT", "label", "Third Party Project Developed In-House", 3, "disabled", "onClick"], [1, "row", "col-md-12", "pl-0"], ["class", "row w-100 mb-3", 4, "ngIf"], ["class", "row col-md-12 pl-0 ml-0", 4, "ngIf"], ["class", "row col-md-12 pl-0 pb-2", 4, "ngIf"], [1, "row", "col-md-12", "p-0"], [1, "row", "col-md-12"], [1, "row", "col-md-12", "pl-0", "mb-3"], [1, "col-md-4", "form-group", "input-disabled"], [1, "label-cls", "positionTitle", "required"], ["formControlName", "jobTitle", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [4, "ngIf"], [1, "row", "col-md-12", "mb-3", "p-0"], [1, "col-md-4", "form-group"], [1, "label-cls", "row", "required"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "startDate", "showIcon", "true", "showButtonBar", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "startDate", 1, "mw-100", 3, "disabled", "showIcon"], [1, "col-md-5", "form-group", "input-disabled"], [1, "row", "label-cls", "required"], ["yearRange", "1900:2100", "id", "endDate", "appendTo", "body", "type", "text", "formControlName", "endDate", "yearNavigator", "true", "monthNavigator", "true", "showIcon", "true", "showButtonBar", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "endDate", 1, "mw-100", 3, "disabled", "showIcon"], [1, "col-md-12", "p-0", "form-group"], [1, "row", "col-md-6"], ["name", "question", 1, "col-md-11", "pl-0", "bold-label"], [1, "label-cls"], ["id", "thisFulltime", "value", "thisFulltime", "formControlName", "thisFulltime", 1, "swtBtn", 3, "disabled"], ["class", "row", 4, "ngIf"], [1, "row", "col-md-12", "p-0", "mb-3"], [1, "label-cls", "required"], [1, "p-input-icon-left", "mask-input", "mw-100"], [1, "pi", "pi-dollar"], ["id", "wagesFrom", "formControlName", "wagesFrom", "type", "text", "pInputText", "", "placeholder", "", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [1, "col-md-4", "processing-dropdown"], ["id", "wageTypeCode", "appendTo", "body", "formControlName", "wageTypeCode", "optionLabel", "name", "optionValue", "code", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], ["id", "wagesPerYear", "formControlName", "wagesPerYear", "type", "text", "pInputText", "", "placeholder", "", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [2, "width", "100%", 3, "parentForm", "disabledControls", "beneficiaryId"], [1, "sub-title", "uploadLetter"], [2, "width", "100%", 3, "fileUploadConfigurations"], [1, "row", "pt-4", "duties-header"], [1, "col-md-12"], [3, "inputData", "isSave", "jobDescription"], [1, "row", "w-100", "mb-3"], [1, "col-md-6", "form-group", "input-disabled"], ["id", "clientName", "formControlName", "clientName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "row", "col-md-12", "pl-0", "ml-0"], ["class", "row col-md-12 pl-0 mb-3", 4, "ngIf"], ["formArrayName", "address", 1, "row", "mb-3"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row", "w-100"], [1, "row", "col-md-12", "save-location"], [1, "row", "col-md-12", "pl-0", "save-location"], ["type", "button", "pButton", "", 1, "mt-1", "p-button-outlined", 3, "disabled", "click"], [1, "col-md-6", "input-disabled"], ["class", "col-md-4 pl-0 pr-0 processing-dropdown", 4, "ngIf"], [1, "col-md-8", "px-0", "input-disabled"], ["type", "text", "placeholder", "Phone Number", "formControlName", "clientPhoneNo", "pInputText", "", "maxlength", "10", "pattern", "\\d{1,10}", 1, "im-input", "mw-100", 3, "readonly"], ["id", "clientEmail", "formControlName", "clientEmail", "pInputText", "", "type", "email", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-4", "pl-0", "pr-0", "processing-dropdown"], ["formControlName", "clientPhoneCode", "optionLabel", "phoneCode", "optionValue", "countryCode", "placeholder", "Select CountryCode", 3, "options", "filter", "disabled"], ["pTemplate", "item"], [1, "p-d-flex", "p-ai-center"], [1, "row", "w-100", 3, "formGroupName"], [1, "col-md-12", "d-flex", "justify-content-end"], ["pButton", "", "pRipple", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", "class", "pull-right p-button-rounded p-button-text", 3, "disabled", "click", 4, "ngIf"], [1, "row", "w-100", "mb-0"], ["id", "addressLine1", "formControlName", "addressLine1", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "addressLine2", "formControlName", "addressLine2", "pInputText", "", "type", "text", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "col-md-3 form-group processing-dropdown", 4, "ngIf"], ["class", "col-md-3 input-disabled", 4, "ngIf"], [1, "col-md-3", "input-disabled"], ["id", "city", "formControlName", "city", "pInputText", "", "type", "text", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["id", "postCode", "formControlName", "postCode", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["class", "mb-3 w-100", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "pull-right", "p-button-rounded", "p-button-text", 3, "disabled", "click"], [1, "col-md-3", "form-group", "processing-dropdown"], ["appendTo", "body", "id", "countryCode", "formControlName", "countryCode", "name", "country", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "select", 3, "options", "disabled", "onChange"], ["appendTo", "body", "id", "stateProvinceCode", "formControlName", "stateProvinceCode", "name", "country", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "select", 3, "options", "disabled"], ["id", "stateProvinceName", "formControlName", "stateProvinceName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "mb-3", "w-100"], [1, "row", "col-md-12", "pl-0", "pb-2"], [1, "row", "col-md-12", "pl-0", "pr-0", "pb-2"], [1, "row", "col-md-12", "pb-2"], ["label", "Is there a middle vendor", "value", "isMiddleVendor", "formControlName", "isMiddleVendor", "binary", "true", 3, "onChange"], ["formArrayName", "vendorList", 1, "row", "mb-3"], ["class", "row col-md-12  mt-4", 4, "ngIf"], ["class", "row col-md-12", 4, "ngFor", "ngForOf"], [1, "row", "col-md-12", "mt-4"], [1, "col-md-4", "pl-0"], [1, "col-md"], [1, "row", "col-md-12", "p-0", 3, "formGroupName"], [1, "col-md-3", "pl-0"], ["formControlName", "vendorName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-3"], ["formControlName", "vendorLastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], ["formControlName", "vendorFirstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "col-md-3", "mt-4"], ["pButton", "", "type", "button", "icon", "pi pi-plus", "title", "Add Vendor", "pTooltip", "Add Vendor", 1, "p-button-raised", "p-button-rounded", 2, "margin-right", "20px", 3, "disabled", "click"], ["pButton", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", "class", "p-button-raised p-button-rounded", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "type", "button", "title", "Delete", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-raised", "p-button-rounded", 3, "disabled", "click"], [1, "label-cls", "workingHr", "required"], ["type", "text", "id", "workingHoursPerWeek", "formControlName", "workingHoursPerWeek", "placeholder", "Enter", "pattern", "\\d{1,5}", "pInputText", "", 1, "im-input", "mw-100", 3, "readonly"]], template: function JobDescriptionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, JobDescriptionLibraryComponent_h5_3_Template, 2, 0, "h5", 3);
        i0.ɵɵtemplate(4, JobDescriptionLibraryComponent_h5_4_Template, 2, 0, "h5", 3);
        i0.ɵɵelementStart(5, "p", 4);
        i0.ɵɵtext(6, " Please provide Work Location, Position Details & List of Duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "ul");
        i0.ɵɵelementStart(9, "li", 6);
        i0.ɵɵelement(10, "lib-step-status-update-component-library", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "li", 8);
        i0.ɵɵelement(12, "lib-maximize-dialog-library", 9);
        i0.ɵɵelementStart(13, "i", 10);
        i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_Template_i_click_13_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵelementStart(16, "lib-assigning-task-library", 13);
        i0.ɵɵlistener("updateStatus", function JobDescriptionLibraryComponent_Template_lib_assigning_task_library_updateStatus_16_listener($event) { return ctx.updateStepStatus($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "p-divider", 14);
        i0.ɵɵelementStart(18, "form", 15);
        i0.ɵɵlistener("ngSubmit", function JobDescriptionLibraryComponent_Template_form_ngSubmit_18_listener() { return ctx.postJobDescription(); });
        i0.ɵɵelementStart(19, "div", 16);
        i0.ɵɵelement(20, "lib-last-update-library", 17);
        i0.ɵɵelement(21, "help-video-overlay-library", null, 18);
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵelementStart(24, "h5", 20);
        i0.ɵɵtext(25, "Identify Work Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 19);
        i0.ɵɵelementStart(27, "div", 21);
        i0.ɵɵelementStart(28, "p-radioButton", 22);
        i0.ɵɵlistener("onClick", function JobDescriptionLibraryComponent_Template_p_radioButton_onClick_28_listener() { return ctx.handleWorkLocationChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(29, JobDescriptionLibraryComponent_div_29_Template, 2, 1, "div", 23);
        i0.ɵɵtemplate(30, JobDescriptionLibraryComponent_div_30_Template, 2, 1, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, JobDescriptionLibraryComponent_div_31_Template, 73, 28, "div", 25);
        i0.ɵɵelement(32, "p-divider");
        i0.ɵɵelement(33, "lib-custom-questionnaire", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(34, "p-divider");
        i0.ɵɵelementStart(35, "div", 27);
        i0.ɵɵelementStart(36, "div", 28);
        i0.ɵɵelement(37, "button", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 30);
        i0.ɵɵelementStart(39, "button", 31);
        i0.ɵɵlistener("click", function JobDescriptionLibraryComponent_Template_button_click_39_listener() { return ctx.handleCancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(40, "div", 30);
        i0.ɵɵelementStart(41, "div", 32);
        i0.ɵɵelement(42, "lib-step-status-update-component-library", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isForeignCompany);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isForeignCompany);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("visaType", ctx.inputData.caseType != "I130" ? ctx.inputData.visatype : ctx.inputData.caseType)("stepDetails", ctx.stepDetails)("isViewMode", ctx.inputData["isViewMode"])("isCaseRequest", ctx.inputData["isCaseRequest"]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(35, _c1, ctx.inputData == null ? null : ctx.inputData.layoutCode));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("visaType", ctx.inputData.visatype)("stepDetails", ctx.stepDetails)("isViewMode", ctx.inputData["isViewMode"])("isCaseRequest", ctx.inputData["isCaseRequest"]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.jobDescriptionForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("inputDetails", ctx.stepDetails)("primaryData", ctx.inputData);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype !== "L1A");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype === "H1-B" || ctx.inputData.layoutCode === "H1_B_POSITION_DETAIL");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobDescriptionForm.get("workLocationTypeCode").value !== null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("stepId", ctx.primaryData.stepId)("taskId", ctx.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", ctx.stepDetails.stepName)("isSection", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c2, (ctx.inputData["isViewMode"] || ctx.inputData["isCaseRequest"]) && ctx.userType == "Attorney"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.jobDescriptionForm.invalid || ctx.disabledControls || !(ctx.jobDescriptionForm.get("selectedRaiobtn").value === 0 || ctx.jobDescriptionForm.get("selectedRaiobtn").value === 1 && (ctx.jobDescriptionForm.get("jobRole").value && (ctx.jobDescriptionForm.get("jobRole").value !== "Other" || ctx.jobDescriptionForm.get("jobRole").value === "Other" && ctx.jobDescriptionForm.get("otherJobPosition").value) && ctx.jobDescriptionForm.get("duties").value && ctx.jobDescriptionForm.get("duties").value.length > 0)) ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx.jobDescriptionForm.invalid || ctx.disabledControls || !(ctx.jobDescriptionForm.get("selectedRaiobtn").value === 0 || ctx.jobDescriptionForm.get("selectedRaiobtn").value === 1 && (ctx.jobDescriptionForm.get("jobRole").value && (ctx.jobDescriptionForm.get("jobRole").value !== "Other" || ctx.jobDescriptionForm.get("jobRole").value === "Other" && ctx.jobDescriptionForm.get("otherJobPosition").value) && ctx.jobDescriptionForm.get("duties").value && ctx.jobDescriptionForm.get("duties").value.length > 0)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("isViewMode", ctx.inputData["isViewMode"])("isCaseRequest", ctx.inputData["isCaseRequest"])("visaType", ctx.inputData.caseType != "I130" ? ctx.inputData.visatype : ctx.inputData.caseType)("stepDetails", ctx.stepDetails)("type", ctx.typeOfButton)("showPreviousStepBtn", ctx.showPrev)("showNextStepBtn", ctx.showNext);
    } }, directives: [i12.NgIf, i13.StepStatusUpdateComponentLibraryComponent, i14.MaximizeDialogLibraryComponent, i15.AssigningTaskLibraryComponent, i16.Divider, i1.ɵangular_packages_forms_forms_ba, i1.NgControlStatusGroup, i1.FormGroupDirective, i17.LastUpdateLibraryComponent, i18.HelpVideoOverlayLibraryComponent, i19.RadioButton, i1.NgControlStatus, i1.FormControlName, i20.CustomQuestionnaireComponent, i12.NgClass, i21.ButtonDirective, i1.DefaultValueAccessor, i22.InputText, i23.Calendar, i24.InputSwitch, i25.Dropdown, i26.H1bJobDescriptionLibraryComponent, i27.FileUploadLibraryComponent, i11.ListJobDutiesComponent, i1.FormArrayName, i12.NgForOf, i1.MaxLengthValidator, i1.PatternValidator, i28.PrimeTemplate, i1.FormGroupName, i29.Tooltip, i30.Checkbox], styles: [".label-cls[_ngcontent-%COMP%]{color:#4a4a4a;font:normal normal normal 14px/20px Source Sans Pro}[_nghost-%COMP%]  .p-checkbox-label{margin-bottom:0}.readOnly-label[_ngcontent-%COMP%]{width:100%;font-size:16px;color:#4a4a4a;padding-top:3px;font-weight:500}.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:18px;font-weight:700}.mask-input[_ngcontent-%COMP%]{width:100%}.pi-dollar[_ngcontent-%COMP%]:before{font-size:13px}.mask-in[_ngcontent-%COMP%]{padding-left:22px}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.label-hint[_ngcontent-%COMP%]{margin-left:10px;font-size:14px;color:#d0c9d6}.chip-content[_ngcontent-%COMP%]{font-size:12px;color:#4d4848}.p-field-checkbox[_ngcontent-%COMP%], .p-field-radiobutton[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.p-inputtext[_ngcontent-%COMP%], .processing-dropdown[_ngcontent-%COMP%]{border-color:#c3d0de!important;font-size:15px!important;color:#3f3356!important;margin-top:10px!important}.p-chips[_ngcontent-%COMP%]   .p-chips-multiple-container[_ngcontent-%COMP%]{border-color:#ced4da!important}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:20px;padding:2px}.mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 22px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 16px/22px Source Sans Pro}.p-radiobutton-label[_ngcontent-%COMP%]{font:normal normal normal 16px/20px Source Sans Pro!important}.save-location[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]{border:none!important;color:#19a0da!important;font:normal normal 600 16px/22px Source Sans Pro!important;right:30px!important}.positionTitle[_ngcontent-%COMP%]{font:normal normal 700 14px/20px Source Sans Pro!important;color:#4a4a4a!important}.bold-label[_ngcontent-%COMP%]   .label-cls[_ngcontent-%COMP%]{color:#4d4f5c!important;font:normal normal 600 16px/20px Source Sans Pro!important}.workingHr[_ngcontent-%COMP%]{font:normal normal normal 13px/18px Source Sans Pro!important;color:#4a4a4a!important}.hideView[_ngcontent-%COMP%]{visibility:hidden}.showView[_ngcontent-%COMP%]{visibility:visible}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'job-description-library',
                templateUrl: 'job-description-library.component.html',
                styleUrls: ['job-description-library.component.scss'],
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.Store }, { type: i3.APIJobDescription }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }, { type: i9.DialogService }, { type: i3.DateValidators }, { type: i10.AppServicesLibraryService }, { type: i11.ListJobDutiesService }]; }, { helpVideoComponent: [{
            type: ViewChild,
            args: [HelpVideoOverlayLibraryComponent, { static: false }]
        }], isForeignCompany: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], deleteAllDutie: [{
            type: Input
        }], addUpdateDuty: [{
            type: Input
        }], deleteDuty: [{
            type: Input
        }], deleteSubDuty: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], jobDescriptionForm: [{
            type: ViewChild,
            args: ['jobDescriptionForm', { static: true }]
        }] }); })();

class JobDescriptionLibraryModule {
}
JobDescriptionLibraryModule.ɵfac = function JobDescriptionLibraryModule_Factory(t) { return new (t || JobDescriptionLibraryModule)(); };
JobDescriptionLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: JobDescriptionLibraryModule });
JobDescriptionLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseJobDescriptionLibraryService], imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            StepStatusUpdateComponentLibraryModule,
            JobDutiesLibraryModule,
            CustomQuestionnaireModule,
            FileUploadLibraryModule,
            H1bJobDescriptionModule,
            LastUpdateLibraryModule,
            HelpVideoOverlayLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            ListJobDutiesModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JobDescriptionLibraryModule, { declarations: [JobDescriptionLibraryComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        StepStatusUpdateComponentLibraryModule,
        JobDutiesLibraryModule,
        CustomQuestionnaireModule,
        FileUploadLibraryModule,
        H1bJobDescriptionModule,
        LastUpdateLibraryModule,
        HelpVideoOverlayLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        ListJobDutiesModule], exports: [JobDescriptionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [JobDescriptionLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    StepStatusUpdateComponentLibraryModule,
                    JobDutiesLibraryModule,
                    CustomQuestionnaireModule,
                    FileUploadLibraryModule,
                    H1bJobDescriptionModule,
                    LastUpdateLibraryModule,
                    HelpVideoOverlayLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    ListJobDutiesModule
                ],
                providers: [BaseJobDescriptionLibraryService],
                exports: [JobDescriptionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of job-description-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JobDescriptionLibraryComponent, JobDescriptionLibraryModule, JobDescriptionLibraryService };
//# sourceMappingURL=job-description-library.js.map
